import { useState, useEffect } from 'react';

const requiredCountries = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

const useRegistrationNum = (
  country: string,
): {
  isRegistrationNumRequired: boolean;
} => {
  const [isRegistrationNumRequired, setIsRegistrationNumRequired] = useState(false);

  useEffect(() => {
    if (requiredCountries.includes(country)) return setIsRegistrationNumRequired(true);
    setIsRegistrationNumRequired(false);
  }, [country]);

  return {
    isRegistrationNumRequired,
  };
};

export { useRegistrationNum };
